/* eslint-disable react/no-multi-comp */
/**
 * Created by sem on 31.10.16.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import Bem from 'bemHelper';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import indexOf from 'lodash/indexOf';
import filter from 'lodash/filter';
import lowerCase from 'lodash/lowerCase';
import includes from 'lodash/includes';
import flatten from 'lodash/flatten';
import getValues from 'lodash/values';
import { close as ddClose, open as ddOpen, focus } from 'components/drop-down';
import DropDown from 'components/drop-down';
import Row, { Col } from 'components/row';
import Button, { btnThemes } from 'components/button';
import Icon, { iconTypes } from 'components/icon';

import { VALIDATION_VALID } from './form-consts';
import AbstractInput from './abstractInput';
import ValidationState from './validationState';
import InputListBox from './input-listbox';
import Input from './input';
import InputLabel from './input-label';

import 'styles/base/containers/form/_input-combobox.scss';

const bemClasses = new Bem('input');
const bemClassesFilter = new Bem('inputFilter');
// Классы для многошаговой модалки
const bemClassesItem = new Bem('itemListbox');
const bemClassesItemBtn = new Bem('btnListbox');

const comboPropTypes = {
  children: PropTypes.node,

  dict: PropTypes.string,

  // Key for id of each item
  dictKey: PropTypes.string,

  // Key for displaying chosen item name
  dictValue: PropTypes.string,

  // Grouping rule for filtering items
  dictGroup: PropTypes.string,

  // If dict can be dynamic, with data filters/processors
  dictDynamic: PropTypes.bool,

  dictSortBy: PropTypes.string,

  disableValidationState: PropTypes.bool,

  // Key for inserted items
  injectPropName: PropTypes.string,

  // TODO: remove this - now is default everywhere
  inForm: PropTypes.bool,

  // Adds top and bottom padding
  list: PropTypes.bool,

  // Combobox multistep mode
  multiStep: PropTypes.bool,

  // Combobox dropdown left alignment
  left: PropTypes.bool,

  // Combobox width depends on it's content
  wAuto: PropTypes.bool,

  // Combobox dropdown direction to top
  topDD: PropTypes.bool,

  // No error message below input (doesn't render empty area)
  noError: PropTypes.bool,

  // TODO: описать пропс
  // arrayMaxLen: PropTypes.bool,

  // Render buttons inside ('Отмена', 'Готово')
  renderDDButtons: PropTypes.bool,

  // Filter items
  enableFilter: PropTypes.bool,

  // Enable outside click event
  enableOnClickOutside: PropTypes.func,

  // Disable outside click event
  disableOnClickOutside: PropTypes.func,

  // Render Combobox without label
  noLabel: PropTypes.bool,

  // Render Combobox with static label
  labelStatic: PropTypes.bool,

  // Modal header text/component when dropdown opens modal (on phone)
  modalHeaderView: PropTypes.oneOf(['green', 'gray']),

  // 'padding: 0' for modalContent
  modalContentNoPadding: PropTypes.bool,

  // show extra label : Multiple select if schema.isArray
  selectMultipleLabel: PropTypes.bool,

  // Custom inline styles (admin pages)
  style: PropTypes.shape({}),
  ...AbstractInput.propTypes,

  // for test
  dataTest: PropTypes.string,

  // for new iconSecondType
  // TODO REMOVE THIS PIECE OF SHIT
  iconSecondType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),

  schema: PropTypes.shape({
    readOnly: PropTypes.bool,
    label: PropTypes.string,
    arrayMaxLen: PropTypes.number,
    isArray: PropTypes.bool,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    dict: PropTypes.any // eslint-disable-line
  }),

  // always render DD instead modal
  alwaysDD: PropTypes.bool,
};

function mapDictIds(props, state) {
  if (!props.dictKey) return state.dictMap;

  const dictMap = {};
  forEach(props[props.injectPropName], val => dictMap[val[props.dictKey]] = val);
  return dictMap;
}

/**
 * Default value renderer
 */
class DefaultValueRenderer extends Component {
  static propTypes = {
    // eslint-disable-next-line
    value: PropTypes.any,
    // eslint-disable-next-line
    dictMap: PropTypes.object,
    dictValue: PropTypes.string,
    placeholder: PropTypes.string,
    multiStep: PropTypes.bool,
    schemaIsArray: PropTypes.bool,
    labelStatic: PropTypes.bool,
  };

  valueByKey(key) {
    const { dictMap = {}, dictValue } = this.props;
    if (!dictMap) return null;
    if (!dictMap[key]) return null;
    return dictMap[key][dictValue];
  }

  renderItems(val) {
    if ((val !== 0 && !val) || (isArray(val) && isEmpty(val)) || this.props.labelStatic) {
      // return 'lable';
      return this.props.placeholder/* || this.props.label */;
    }
    if (isArray(val)) {
      let values = [];
      if (this.props.multiStep) {
        val.map(key => values.push(key));
      } else {
        val.map(key => values.push(this.valueByKey(key)));
      }
      values = values.filter(n => n !== null);
      return values.join(', ');
    }
    return this.valueByKey(val);
  }

  render() {
    return (
      <span>
        {this.renderItems(this.props.value, this.props.schemaIsArray)}
      </span>
    );
  }
}

@onClickOutside
class ComboboxInput extends AbstractInput {
  static propTypes = comboPropTypes;

  static defaultProps = {
    dictKey: 'id',
    dictValue: 'value',
    disableValidationState: false,
    injectPropName: 'listBoxItems',
    list: true,
    inForm: true,
    dictDynamic: false,
    selectMultipleLabel: true,
    iconSecondType: iconTypes.carret
  };

  static modifyInjected(injected, dictKey) {
    const injectedProps = {};
    forEach(injected, prop => injectedProps[prop[dictKey]] = prop);

    return injectedProps;
  }

  static bustProps(props) {
    const { dictKey, dictValue, value, schema = {}, multiStep, injectPropName } = props;
    const schemaValIsArray = schema.isArray;
    let injectedProps = props[injectPropName];
    const params = {
      arrayItems: [],
      countChild: {},
    };

    if (isArray(injectedProps)) {
      injectedProps = ComboboxInput.modifyInjected(injectedProps, dictKey);
    }

    const fillParams = (obj, parentId = null) => forEach(obj, (elem) => {
      if (elem[dictKey]) {
        if (elem.children && !isEmpty(elem.children)) {
          return fillParams(
            elem.children,
            parentId ?
              [...parentId, elem[dictKey]] :
              [elem[dictKey]]
          );
        } else if (
          elem[dictKey] === value ||
          (elem && elem[dictKey] && isArray(value)
            && indexOf(value, elem[dictKey]) > -1)
        ) {
          if (schemaValIsArray) {
            const indexOfTip = indexOf(value, elem[dictKey]);
            params.arrayItems[indexOfTip] = elem[dictValue];
          } else {
            params.arrayItems[0] = elem[dictValue];
          }

          if (multiStep && parentId) {
            let i = 0;
            const parentIdLength = parentId.length;
            for (i; i < parentIdLength; i += 1) {
              const curLevel = `level${i}`;
              if (!params.countChild[curLevel]) {
                params.countChild[curLevel] = {};
              }
              if (!params.countChild[curLevel][parentId[i]]) {
                params.countChild[curLevel][parentId[i]] = 1;
              } else params.countChild[curLevel][parentId[i]] += 1;
            }
          }
        }
      }
    });

    fillParams(injectedProps, null);

    return params;
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {
      dictMap: mapDictIds(props, state)
    };

    const { value, dictValue } = props;

    if (state.dictMap && state.dictMap[value] && !state.showContentVariants) {
      newState.inputValue = state.dictMap[value][dictValue];
    }

    return newState;
  }

  constructor(props) {
    super(props);
    this.groupedProps = [];
    this.filteredProps = null;
    this.changed = false;
    this.valueRenderer = this.props.valueRenderer || DefaultValueRenderer;
    this.handleChange = this.handleChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.closeDDFromListbox = this.closeDDFromListbox.bind(this);
    this.focusFromListBox = this.focusFromListBox.bind(this);
    this.setDDOpened = this.setDDOpened.bind(this);
    this.setDDClosed = this.setDDClosed.bind(this);
    this.openDDfromRef = this.openDDfromRef.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.resetFilteredGroupProps = this.resetFilteredGroupProps.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.showContentVariants = this.showContentVariants.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

    // this._idContainer = this.getUid(); TODO check, is this really needed
    const injectedProps = this.props[this.props.injectPropName];
    // TODO implement custom value renderer
    this.input =
      !isEmpty(props.children) ?
        props.children[0] :
        props.children || <InputListBox />;

    if (props.enableFilter) {
      this.groupElements(injectedProps);
    }

    this.props.disableOnClickOutside();

    this.state = {
      focused: false,
      showContentVariants: false,
      inputValue: null,
      dictMap: mapDictIds(props, {})
    };
  }

  componentDidUpdate() {
    if (this.props.enableFilter && this.changed) {
      this.resetFilteredGroupProps();
      if (this.props.value === null) {
        this.filteredProps = null;
        this.groupElements(this.props[this.props.injectPropName]);
      }
      this.changed = false;
    }
  }

  handleChange(val, item) {
    const value = val;
    const { schema = {} } = this.props;
    if (schema && schema.readOnly) return;
    if (this.props.enableFilter && val !== this.props.value) this.changed = true;
    // if (schema.isArray && !isArray(this.props.value)) value = [value];
    if (schema.arrayMaxLen && value.length > schema.arrayMaxLen) return;

    this.props.onChange(value);
    this.performValidation(value);

    if (
      !schema.isArray || (
        this.props.multiStep && !schema.isArray &&
        item && item.children && isEmpty(item.children)
      )
    ) this.closeDDFromListbox();
  }

  focusFromListBox() {
    // if (this.ddRef) {
    //   focus(this.ddRef);
    // }
  }

  closeDDFromListbox() {
    if (this.ddRef) {
      this.ddRef.getInstance().close();
    }
  }

  renderInput(countChild) {
    const { injectPropName, enableFilter } = this.props;
    return React.cloneElement(this.input, {
      ...this.props,
      className: null,
      levels: countChild,
      onChange: this.handleChange,
      [injectPropName]: enableFilter ? this.groupedProps : this.props[injectPropName],
      displayLabel: false,
      focusFromListBox: this.focusFromListBox,
      closeFromListBox: this.closeDDFromListbox,
      ref: ref => this.inputRef = ref
    });
  }

  onKeyDown(event) {
    const { schema = {} } = this.props;
    if (schema.readOnly) return;
    const filterInputActive = this.props.enableFilter && this.state.showContentVariants;
    switch (event.keyCode) {
      /* left = 37
        up = 38
        right = 39
        down = 40 */

      case 37: // left
      case 39: // right
        event.preventDefault();
        if (this.ddIsOpened && this.inputRef && this.inputRef.keyNavigation) {
          this.inputRef.keyNavigation(event);
        }
        break;

      case 38: // up
        event.preventDefault();
        if (!this.ddIsOpened && this.ddRef) {
          ddOpen(this.ddRef);
        } else if (this.inputRef && this.inputRef.keyNavigation) {
          this.inputRef.keyNavigation(event);
        }
        break;

      case 40: // down
        event.preventDefault();
        if (!this.ddIsOpened && !this.props.enableFilter) {
          ddOpen(this.ddRef && this.ddRef);
        } else if (this.inputRef && this.inputRef.keyNavigation) {
          this.inputRef.keyNavigation(event);
        }
        break;

      case 13: // enter
        event.preventDefault();
        if (!this.ddIsOpened && this.ddRef) {
          ddOpen(this.ddRef);
        } else if (this.inputRef && this.inputRef.keyNavigation) {
          this.inputRef.keyNavigation(event);
        }
        break;

      case 27: // escape
        if (this.ddRef) {
          ddClose(this.ddRef);
          event.preventDefault();
        } else if (filterInputActive) {
          this.handleClickOutside();
          this.onInputBlur();
          event.preventDefault();
        }
        break;

      case 9: // Tab
        if (this.ddIsOpened) {
          ddClose(this.ddRef);
          // event.preventDefault();
        } else if (filterInputActive) {
          this.handleClickOutside();
        }
        break;

      case 32: // space
        if (this.props.enableFilter) return;
        event.preventDefault(event);
        if (!this.ddIsOpened && this.ddRef) {
          this.ddIsOpened = true;
          ddOpen(this.ddRef);
        } else if (this.inputRef && this.inputRef.keyNavigation) {
          this.inputRef.keyNavigation(event);
        }
        break;
      default:
      // do nothing
    }
  }

  setDDOpened() {
    const { schema = {} } = this.props;
    if (schema.readOnly) return;
    this.ddIsOpened = true;
  }

  setDDClosed() {
    const { schema = {} } = this.props;
    if (schema.readOnly) return;
    if (this.inputRef) this.inputRef.resetMultiStepLevels();
    this.ddIsOpened = false;
  }

  openDDfromRef() {
    this.ddButton.click();
    // if (this.ddRef) ddOpen(this.ddRef);
  }

  handleCancelClick() {
    this.props.onChange(null);
    return ddClose(this.ddRef);
  }

  resetFilteredGroupProps(resetInputValue = false) {
    if (this.state.showContentVariants) {
      if (!resetInputValue) this.setInputValue(); else this.onInputChange(null);
      this.onInputBlur();
      this.handleClickOutside();
    }
  }

  handleClickOutside() {
    if (this.state.showContentVariants) this.setState({ showContentVariants: false });
    this.props.disableOnClickOutside();
  }

  close() {
    this.handleClickOutside();
  }

  groupElements(props) {
    const { dictKey, dictValue, dictGroup } = this.props;
    const propsLength = props.length - 1;
    if (
      !dictGroup ||
      (!propsLength && props[0].noMatchesFound)
    ) return this.groupedProps = props;

    this.groupedProps.length = 0;
    const groups = {};

    if (!propsLength && props[0][dictKey] !== null) {
      return this.groupedProps = [
        {
          [dictKey]: `group_${dictKey}`,
          [dictValue]: props[0][dictGroup],
          listboxGroupLabel: true
        },
        props[0]
      ];
    }
    forEach(props, (item) => {
      if (!groups[item[dictGroup]]) {
        groups[item[dictGroup]] = [];
        groups[item[dictGroup]].push({
          [dictKey]: `group_${dictKey}`,
          [dictValue]: item[dictGroup],
          listboxGroupLabel: true
        });
      }
      groups[item[dictGroup]].push(item);
    });
    this.groupedProps = flatten(getValues(groups));
  }

  onInputChange(value) {
    const { dictKey, dictValue, injectPropName } = this.props;
    const propsArray = this.props[injectPropName];
    const lowCaseValue = lowerCase(value);
    if (!this.state.showContentVariants) { this.setState({ showContentVariants: true }); }
    if (value || value === 0) {
      this.filteredProps = filter(propsArray,
        item => includes(lowerCase(item[dictValue]), lowCaseValue));
      if (isEmpty(this.filteredProps)) {
        this.filteredProps.push({ [dictKey]: null,
          [dictValue]:
            'Совпадений не найдено',
          noMatchesFound: true });
      }
      this.groupElements(this.filteredProps);
    } else {
      // if (this.props.value !== null) this.props.onChange(null);
      this.filteredProps = null;
      this.groupElements(propsArray);
    }

    if (value !== this.state.inputValue) this.setState({ inputValue: value || '' });
  }

  showContentVariants() {
    if (this.state.inputValue) this.onInputChange(this.state.inputValue);
    this.setState({ showContentVariants: true });
    this.props.enableOnClickOutside();
  }

  setInputValue() {
    const { value, dictValue } = this.props;
    if (this.state.dictMap && this.state.dictMap[value]) {
      this.setState({ inputValue: this.state.dictMap[value][dictValue] });
    } else {
      this.setState({ inputValue: null });
    }
  }

  onInputBlur() {
    // this.filterInput.blur();
    // this.filterInput.handleBlur(); // persist
  }

  labelRenderer(schema, selectMultipleLabel) {
    const { isArray: schemaIsArray, arrayMaxLen, label } = schema;
    let labelText = schemaIsArray && selectMultipleLabel
      ? `${label} (выбор нескольких)`
      : label;
    if (arrayMaxLen) labelText = `${label} (выбор нескольких, максимум ${arrayMaxLen})`;

    return (
      <InputLabel
        {...bemClasses('inputLabel')}
        schema={{
          ...schema,
          label: labelText
        }}
        value={this.props.value}
        validationState={this.props.validationState}
        inside
      />
    );
  }

  handleMultiStepClick(goForward, it, noChildren, val) {
    const { schema = {}, unselectableNonArrayInput } = this.props;
    let { value } = this.props;

    if (noChildren) {
      if (schema.isArray) {
        value = isArray(value) ? value : [];
        const isInSelectedArray = value.indexOf(val) > -1;

        // *** Value, that unset all previous choices
        if (typeof schema.unsetValue !== 'undefined') {
          if (schema.unsetValue === val) {
            value = [];
          } else {
            value = value.filter(some => some !== schema.unsetValue);
          }
        }

        value = isInSelectedArray
          ? value.filter(some => some !== val)
          : [...value, val];

        this.handleChange(value, {});
      }

      if (!schema.isArray) {
        if (unselectableNonArrayInput && val === value) return this.handleChange(null);
        this.handleChange(val, it);
      }

      return;
    }

    goForward(it);
  }

  renderMultiStepContent({ goForward, parent, currentStep }, countChild) {
    const { dictKey, schema = {}, value } = this.props;
    const count = countChild[`level${currentStep}`] || {};

    return (
      <div>
        {map(parent, (it, key) => {
          const val = it[dictKey];
          const noChildren = !it.children || isEmpty(it.children);
          const active = value && schema.isArray ? value.indexOf(val) >= 0 : value === val;

          return (
            <Button
              {...bemClassesItemBtn()}
              key={key}
              onClick={() => this.handleMultiStepClick(goForward, it, noChildren, val)}
              customRenderer
            >
              <span {...bemClassesItem('itemListbox')}>
                <span {...bemClassesItem('content')}>
                  {noChildren && (active
                    ? <Icon {...bemClassesItem('icon')} type={iconTypes.check} />
                    : <span {...bemClassesItem('icon')} />
                  )}
                  <span {...bemClassesItem('text')}>{it[this.props.dictValue]}</span>
                  {!noChildren &&
                    <React.Fragment>
                      {count[val] > 0 && <span {...bemClassesItem('text', 'second')}>{schema.isArray && count[val]}</span>}
                      <Icon {...bemClassesItem('icon', 'second hasChildren')} type={iconTypes.carretRight} />
                    </React.Fragment>
                  }
                </span>
              </span>
            </Button>
          );
        })}
      </div>
    );
  }

  render() {
    const injectedProps = this.props[this.props.injectPropName];
    const { arrayItems, countChild } = ComboboxInput.bustProps(this.props);

    const {
      schema = {}, dictValue, value, multiStep, enableFilter,
      inForm, list, wAuto, topDD, left, noError, noLabel, dataTest,
      modalHeaderView, modalContentNoPadding, style, className,
      iconSecondType, alwaysDD, labelStatic
    } = this.props;
    const required = schema.required;
    const empty = this.props.disableValidationState;
    const validationState =
      this.props.validationState ? this.props.validationState.state : VALIDATION_VALID;
    const mods = {
      required,
      empty,
      error: validationState !== VALIDATION_VALID,
      enableFilter,
      disabled: schema.readOnly
    };
    let valueSelected = false;
    const valIsArray = isArray(value);
    if ((valIsArray && value.length > 0) || (!valIsArray && value !== null)) valueSelected = true;

    if (enableFilter) {
      return (
        <div {...bemClassesFilter(null, mods, className)} data-test={dataTest}>
          <Input
            {...bemClassesFilter('input')}
            ref={input => this.filterInput = input}
            value={this.state.inputValue || ''}
            onChange={this.onInputChange}
            clearInputCallBack={this.resetFilteredGroupProps}
            onFocusCallback={this.showContentVariants}
            onKeyDown={this.onKeyDown}
            schema={schema}
          />
          {this.state.showContentVariants &&
            <div
              {...bemClassesFilter('dropDown__content')}
              children={this.renderInput()}
            />
          }
        </div>
      );
    }

    return (
      <div
        {...bemClasses(null, mods, className)}
        data-test={dataTest}
        style={style}
      >
        <div {...bemClasses('inputWrapper')}>
          <div {...bemClasses('inputContainer')} data-test="selectPlace">
            <DropDown
              {...bemClasses('dropDown', {
                valueSelected,
                error: validationState !== VALIDATION_VALID,
                // opened: schema && schema.placeholder && schema.label
              })}
              onOpen={this.setDDOpened}
              autoDirection
              onClose={this.setDDClosed}
              ref={el => this.ddRef = el}
              inForm={inForm}
              list={list}
              left={left}
              wAuto={wAuto}
              topDD={topDD}
              schema={schema}
              modalHeader={schema.label}
              modalHeaderView={modalHeaderView}
              modalContentNoPadding={modalContentNoPadding}
              multiStep={multiStep}
              multiStepData={injectedProps}
              multiStepContent={props => this.renderMultiStepContent(props, countChild)}
              multiStepHeaderField={dictValue}
              alwaysDD={alwaysDD}
            >
              <Button
                {...bemClasses('btn', 'dropDown')}
                onKeyUp={event => event.preventDefault()}
                onKeyDown={this.onKeyDown}
                label={
                  <this.valueRenderer
                    value={multiStep ? arrayItems : value}
                    // value={value}
                    dictMap={this.state.dictMap}
                    dictValue={this.props.dictValue}
                    placeholder={schema.placeholder}
                    label={schema.label}
                    multiStep={multiStep}
                    schemaIsArray={schema.isArray}
                    labelStatic={labelStatic}
                  />
                }
                wRef={ref => this.ddButton = ref}
                // TODO REMOVE THIS FUCKING SHIT
                iconSecondType={!schema.readOnly && iconSecondType}
                contentLeft
              />
              <div {...bemClasses('dropDown__content', { multiStep })} data-test="dropDownContent">
                {!schema.readOnly && this.renderInput(countChild)}
                {this.props.renderDDButtons &&
                  <div {...bemClasses('dropDown__contentFooter')}>
                    <div {...bemClasses('dropDown__contentFooterContentContainer')}>
                      <Row noMaxW allAuto allJustifyCFlexEnd {...bemClasses('dropDown__contentFooterContent')}>
                        <Col allPr={0}>
                          <Button
                            onClick={this.handleCancelClick}
                            label="Отмена"
                            theme={btnThemes.main}
                            big
                          />
                        </Col>
                        <Col allPr={0} allPl={20}>
                          <Button
                            onClick={() => ddClose(this.ddRef)}
                            label="Готово"
                            theme={btnThemes.main}
                            big
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                }
              </div>
            </DropDown>
            {!noLabel && schema && schema.label &&
              this.labelRenderer(schema, this.props.selectMultipleLabel)
            }
            <span {...bemClasses('bottomLine')} />
          </div>
          {!noError &&
            <div {...bemClasses('errorWrapper')}>
              {!this.props.disableValidationState &&
                <ValidationState validationState={this.props.validationState} />
              }
            </div>
          }
        </div>
      </div>
    );
  }
}

export default class ComboboxInputAutoDict extends Component {
  static propTypes = comboPropTypes;

  constructor(...props) {
    super(...props);
    this.getComponentMethods = this.getComponentMethods.bind(this);
  }

  /**
   * Get specific method out from combobox
   *
   * = Example =
   * this.comboboxRef.getComponentMethods('onKeyDown', event);
   *
   * @param method
   * @param args
   * @returns {func}
   */
  getComponentMethods(method, ...args) {
    return this.comboRef.getInstance()[method](...args);
  }

  render() {
    const { schema = {} } = this.props;
    if (schema.dict) {
      return (
        <ComboboxInput
          {...this.props}
          listBoxItems={schema.dict}
          ref={ref => this.comboRef = ref}
        />
      );
    }
    return <ComboboxInput ref={ref => this.comboRef = ref} {...this.props} />;
  }
}
